import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setLoading } from '../redux/slices/authSlice';
import { useAuthService } from '../services/authService';
import { useLogout } from './useLogout';

export const useAuth = () => {
  const dispatch = useDispatch();
  const { user, isAuthenticated, isLoading, login, getToken } = useAuthService();
  const { logout } = useLogout();

  // Update Redux state when Auth0 state changes
  useEffect(() => {
    dispatch(setLoading(isLoading));
    
    if (!isAuthenticated && !isLoading) {
      console.warn('User is not authenticated');
    }
  }, [user, isAuthenticated, isLoading, dispatch]);

  const authState = {
    user: user,
    isAuthenticated: isAuthenticated,
    isLoading: isLoading,
    error: '',
    login,
    logout,
    getToken,
    getClaim: (claim: string) => user?.[claim],
    claims: user || {},
  };

  return authState;
}; 